type TrainingGuideStep = {
  stepTitle: string
  stepDescription: string | React.ReactNode
  contentTitle: string
  contentDescription: string
  contentIcon: string
  numberedListIntro: string
  asset?: string
  numberedList?: string[]
  numberedListEnd?: string
}

export const trainingGuideSteps: TrainingGuideStep[] = [
  {
    stepTitle: 'Getting Started',
    stepDescription: '',
    contentTitle: 'Getting Started with PhysicianGPS',
    contentDescription: 'Accessing the Portal',
    contentIcon: '/assets/training-guide/illustrations/magnifying-glass.png',
    numberedListIntro: 'Getting set up is quick and easy:',
    asset: '/assets/training-guide/gifs/training-guide-step-1.gif',
    numberedList: [
      'Use your work email address to register.',
      "Create a password that's secure and easy to remember.",
      'Click "Create Account" — and you\'re in!',
    ],
  },
  {
    stepTitle: 'Search Physician',
    stepDescription: '',
    contentTitle: 'Searching for a Physician',
    contentDescription: 'Finding the right doctor for you',
    contentIcon: '/assets/training-guide/illustrations/stethoscope.png',
    numberedListIntro:
      "When you land on the homepage, you'll see multiple ways to start your search:",
    asset: '/assets/training-guide/gifs/training-guide-step-2.gif',
    numberedList: [
      'By Specialty – Explore providers by their area of expertise (e.g., Cardiology, Orthopedics).',
      "By Name – Already know who you're looking for? Just type in their name.",
      'By Condition – Not sure which type of doctor you need? Search by your health concern instead.',
    ],
    numberedListEnd:
      "You'll also notice quick-access options under Top Searched Specialties, making it simple to get started with popular categories.",
  },
  {
    stepTitle: 'Filters & Results',
    stepDescription: '',
    contentTitle: 'Applying Filters & Viewing Results',
    contentDescription: 'Applying Filters & Viewing Results',
    contentIcon: '/assets/training-guide/illustrations/bulls-eye.png',
    numberedListIntro:
      "Once you've entered your search, use the available filters to narrow things down and find the care that fits your needs. You can:",
    asset: '/assets/training-guide/gifs/training-guide-step-3.gif',
    numberedList: [
      'Filter by condition, specialty, or treatment type',
      'Set your location — click "Use my current location" for quick access',
      'Refine by preferences, such as:',
      '- Doctors who offer online appointment booking',
      '- Providers with telehealth options',
      '- Filter by physician gender',
      '- Filter by insurance plans accepted',
      "- Need Help? We've Got You",
    ],
  },
  {
    stepTitle: 'Physician Profile',
    stepDescription: '',
    contentTitle: "Viewing a Physician's Profile",
    contentDescription: "Viewing a Physician's Profile",
    contentIcon: '/assets/training-guide/illustrations/physician-picture.png',
    numberedListIntro:
      "Clicking on a physician's name in your results takes you to their full profile — giving you a comprehensive look before you book. You'll find:",
    asset: '/assets/training-guide/gifs/training-guide-step-4.png',
    numberedList: [
      'A photo and a quick snapshot of their background',
      'Availability and location details',
      'Their experience, affiliations, and other professional highlights',
      'A list of accepted insurance plans',
      'A phone number for appointment setting',
    ],
  },
  {
    stepTitle: 'Appointment Booking',
    stepDescription: '',
    contentTitle: 'Booking an Appointment',
    contentDescription: 'Booking an Appointment',
    contentIcon: '/assets/training-guide/illustrations/calendar.png',
    numberedListIntro: 'When you find the right doctor, scheduling is simple:',
    asset: '/assets/training-guide/gifs/training-guide-step-5.gif',
    numberedList: [
      "Click 'Schedule Appointment' on the physician's profile",
      'Choose available time slot',
      'Confirm appointment details',
      'Receive confirmation email',
    ],
  },
  {
    stepTitle: 'Support & Assistance',
    stepDescription: '',
    contentTitle: "Need Help? We've Got You.",
    contentDescription: 'Not sure what to search for?',
    contentIcon: '/assets/training-guide/illustrations/bubble-speech.png',
    numberedListIntro:
      'Chat with our AI-powered assistant anytime, or connect directly with our Member Experience Team for personalized support.',
    asset: '/assets/training-guide/gifs/training-guide-step-6.gif',
    numberedList: [
      'Visit the FAQ section for answers to common questions.',
      'Our Care Navigation Team is here to make your journey easier.',
      'They can help you with:',
      '- Understanding and using your health benefits',
      '- Scheduling appointments with top-tier providers',
      '- Sending reminders so you never miss a visit',
      '- Providing timely care nudges based on your needs',
    ],
    numberedListEnd: "You're never on your own with PhysicianGPS.",
  },
  {
    stepTitle: 'Find your Physician',
    stepDescription: '',
    contentTitle: 'Thank You for Choosing PhysicianGPS',
    contentDescription: '',
    contentIcon: '/assets/training-guide/illustrations/high-five.png',
    numberedListIntro:
      "We're proud to support you in making confident healthcare decisions. Together, we're making care easier to access and better for everyone.",
    numberedListEnd: "Let's get started.",
  },
]
